import { type Components } from '@mui/material';
import { HorizonTheme } from './horizon-theme';

export const muiDialogActions: Components<HorizonTheme>['MuiDialogActions'] = {
  defaultProps: {
    disableSpacing: true,
  },
  styleOverrides: {
    root: {
      padding: 24,
    },
  },
};
